import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Add app to home screen? ")

import { onBeforeMount, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  name: 'PWAPrompt',
  setup(__props) {

const shown = ref(false);
const installEvent = ref();

function dismissPrompt() {
  shown.value = false;
}

function installPWA() {
  installEvent.value.prompt();
  installEvent.value.userChoice.then(
    (choice: { outcome: "accepted" | "dismissed" }) => {
      dismissPrompt(); // Hide the prompt once the user's clicked
      if (choice.outcome === "accepted") {
        // Do something additional if the user chose to install
      } else {
        // Do something additional if the user declined
      }
    }
  );
}

onBeforeMount(() => {
  window.addEventListener("beforeinstallprompt", e => {
    e.preventDefault();
    installEvent.value = e;
    shown.value = true;
  });
});

return (_ctx: any,_cache: any) => {
  return (shown.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("button", { onClick: installPWA }, "Install!"),
        _createElementVNode("button", { onClick: dismissPrompt }, "No, thanks")
      ]))
    : _createCommentVNode("", true)
}
}

})